import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApi } from '../../hooks/useApi'
import { TelegramIcon, GamepadIcon, GiftCardIcon } from '../../components/BrandIcons'
import { Loader2, AlertTriangle, Package } from 'lucide-react'

const ProductList = () => {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const api = useApi()

  useEffect(() => {
    api.getProducts().then(data => setProducts(data.products || [])).catch(err => setError(err.message)).finally(() => setLoading(false))
  }, [])

  const categories = Object.entries(
    products.reduce((acc, p) => {
      const cat = p.category || 'other'
      if (!acc[cat]) acc[cat] = []
      acc[cat].push(p)
      return acc
    }, {})
  )

  const categoryConfig = {
    telegram: { label: 'Telegram', icon: TelegramIcon, img: 'https://api.g2bulk.com/images/telegram.jpeg', bg: '#2AABEE' },
    pubgm: { label: 'PUBG Mobile', icon: GamepadIcon, img: 'https://api.g2bulk.com/images/pubgm.png', bg: '#F2A900' },
    gaming: { label: 'Gaming', icon: GamepadIcon, img: null, bg: '#8b5cf6' },
    giftcard: { label: 'Gift Cards', icon: GiftCardIcon, img: null, bg: '#059669' },
    other: { label: 'Other', icon: Package, img: null, bg: '#6b7280' },
  }

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 size={28} className="animate-spin text-gray-400" /></div>
  }

  if (error) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4">
        <div className="text-center">
          <AlertTriangle size={28} className="mx-auto text-gray-400 mb-3" />
          <p className="text-gray-500 text-sm">{error}</p>
          <button onClick={() => window.location.reload()} className="btn btn-primary mt-3">Retry</button>
        </div>
      </div>
    )
  }

  return (
    <div className="container mx-auto px-4 py-10 max-w-3xl">
      <div className="text-center mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">Redeem Your Code</h1>
        <p className="text-gray-500 text-sm">Select a category to get started</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {categories.map(([category, items]) => {
          const config = categoryConfig[category] || categoryConfig.other
          const Icon = config.icon

          return (
            <button
              key={category}
              onClick={() => navigate(`/redeem/${category}`)}
              className="bg-white border border-gray-200 rounded-2xl p-5 flex items-center space-x-4 hover:border-gray-300 hover:shadow-md transition-all group text-left"
            >
              {config.img ? (
                <img src={config.img} alt="" className="w-14 h-14 rounded-xl object-cover flex-shrink-0" />
              ) : (
                <div className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: config.bg }}>
                  <Icon size={28} className="text-white" />
                </div>
              )}
              <div>
                <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-600 transition-colors">{config.label}</h3>
                <p className="text-gray-400 text-sm">
                  {category === 'telegram' ? 'Redeem Stars & Premium' :
                   category === 'pubgm' ? 'Redeem Prime, Elite & special packs' :
                   category === 'gaming' ? 'Redeem Game Top-ups' :
                   category === 'giftcard' ? 'Redeem Gift Cards' : 'Redeem Codes'}
                </p>
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default ProductList
